import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import "./styles.scss";

const VerticalNavBar = (props) => {
  const [current, setCurrent] = useState(0);
  const [allSection, setAllSection] = useState<any[]>([]);
  let isManualScroll = useRef(true);

  const check = () => {
    if (isManualScroll.current) {
      allSection.forEach((item, index) => {
        const el = document && document.getElementById(item.uid);
        if (el) {
          if (isInViewport(el)) {
            setCurrent(index);
          }
        }
      });
    }
  };
  useEffect(() => {
    window?.addEventListener("scroll", check);

    return () => {
      window?.removeEventListener("scroll", check);
    };
  });

  useLayoutEffect(() => {
    const allSectionData = props.data.placeholders["jss-main"];
    const allSectionArr = allSectionData.map((section) => {
      return {
        uid: section.uid,
        tooltip: section?.fields?.Tooltip?.value,
        name: section.componentName,
      };
    });

    const tempArr = allSectionArr.filter((item) => {
      return item.tooltip && item.tooltip != "";
    });

    setAllSection(tempArr);
  }, []);

  // let timeOut;
  // useEffect(()=>{
  //    if(!timeOut){
  //     timeOut =  setTimeout(() => {
  //         isManualScroll.current = true;

  //     }, 1000);
  //    }else{
  //     clearTimeout(timeOut);
  //    }

  // },[current])

  const isInViewport = (element) => {
    const rect = element?.getBoundingClientRect();

    const notvisible =
      rect?.bottom -
      ((window && window.innerHeight )|| (document && document.documentElement.clientHeight));
    const percentvisible = 100 - (notvisible * 100) / rect.height;

    return (
      (window && window.innerHeight || (document && document.documentElement.clientHeight)) - rect.top >
      200
    );

    //return percentvisible > 30
  };

  const delay = (div, timmimg) => {
    setTimeout(() => {
      const rect = div?.getBoundingClientRect();
      if (
        rect?.height >
        (window?.innerHeight || document.documentElement.clientHeight)
      ) {
        div?.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest",
        });
      } else {
        div?.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "nearest",
        });
      }
    }, timmimg);
  };

  const lazyArr = useRef({});
  const setLazyflag = (id) => {
    if (!lazyArr.current[id]) {
      lazyArr.current[id] = true;
    }
  };
  const getLazyFlag = (id) => {
    if (!lazyArr.current[id]) {
      lazyArr.current[id] = true;
      return true;
    } else {
      return false;
    }
  };

  const scrollTo = (item, index) => {
    window?.removeEventListener("scroll", check);
    isManualScroll.current = false;

    const tempArr = allSection.filter((item) => {
      return item.tooltip && item.tooltip != "";
    });

    if (index > current && getLazyFlag(item.uid)) {
      tempArr.forEach((item, i) => {
        if (i >= current && i <= index) {
          const div = document && document.getElementById(item.uid);
          setLazyflag(item.uid);
          delay(div, 50 * i);
        }
      });
      setCurrent(index);
    } else {
      setCurrent(index);
      const div = document && document.getElementById(item.uid);
      const rect = div?.getBoundingClientRect();
      if (
        (rect?.height ?? 0) >
        ((window && window.innerHeight) || (document && document.documentElement.clientHeight))
      ) {
        div?.scrollIntoView({
          behavior: "auto",
          block: "start",
          inline: "nearest",
        });
      } else {
        div?.scrollIntoView({
          behavior: "auto",
          block: "end",
          inline: "nearest",
        });
      }
    }

    isManualScroll.current = true;
  };

  return (
    <div className="vertical-nav" id={props?.rendering?.uid}>
      {allSection &&
        allSection.map((item, index) => {
          return (
            <React.Fragment key={index}>
              {item.tooltip != "" && item.name != "VerticalNavBar" && (
                <span
                  className={`vertical-nav__dot-wrapper${
                    current === index ? "--active" : ""
                  }`}
                  onClick={() => {
                    scrollTo(item, index);
                  }}
                >
                  <div
                    className={`tooltip vertical-nav__dots ${
                      current === index ? "vertical-nav__dots--active" : ""
                    }`}
                  >
                    <span className="tooltiptext">{item.tooltip}</span>
                  </div>
                </span>
              )}
            </React.Fragment>
          );
        })}
    </div>
  );
};

export default VerticalNavBar;
